import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_brandhero-hiring/artifacts/aaahru5o_logo.svg";

export const BrandMark = ({ className = "", compact = false }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-mark">
    <img
      src={LOGO_URL}
      alt="Brandhero"
      className={`bh-logo-on-dark ${compact ? "h-5" : "h-6 sm:h-7"} w-auto select-none`}
      draggable={false}
    />
    {!compact && (
      <div className="leading-tight border-l border-white/15 pl-3 hidden sm:block">
        <div className="text-[0.55rem] uppercase tracking-[0.28em] text-zinc-400 font-bold">
          × HBTU
        </div>
        <div className="text-[0.55rem] uppercase tracking-[0.25em] text-zinc-500">
          Campus Challenge
        </div>
      </div>
    )}
  </div>
);

export const Header = ({ right = null }) => (
  <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/70 border-b border-white/10">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
      <BrandMark />
      <div className="flex items-center gap-4">{right}</div>
    </div>
  </header>
);

export const SectionLabel = ({ children, className = "" }) => (
  <div className={`bh-section-label ${className}`}>{children}</div>
);
